"use strict";
(self["webpackChunktvg_shopify_theme"] =
  self["webpackChunktvg_shopify_theme"] || []).push([
  [938],
  {
    694: (
      __unused_webpack_module,
      __unused_webpack___webpack_exports__,
      __webpack_require__
    ) => {
      var swiper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(488);
      var jquery__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(898);
      var jquery__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(
        jquery__WEBPACK_IMPORTED_MODULE_1__
      );
      var _core_shopify_init_section_index_js__WEBPACK_IMPORTED_MODULE_2__ =
        __webpack_require__(170);
      const navigationItems = ".js-simple-featured-products-nav-item";
      const navigationAll = ".js-simple-featured-products-nav-all";
      const NAMESPACE =
        ".simple_featured_products_carousel_6035fe20aca44b75918bd03f0fe491e7";
      const SWIPER_ELEMENT = ".js-simple-featured-products-carousel";
      const featuredSlide = ".js-simple-featured-products-carousel-slide";
      let mySwiper;
      (0,
      _core_shopify_init_section_index_js__WEBPACK_IMPORTED_MODULE_2__.initSection)(
        ".js-simple-featured-products",
        (_section) => {
          const section =
            jquery__WEBPACK_IMPORTED_MODULE_1___default()(_section);
          const swiperElement = document.querySelector(SWIPER_ELEMENT);
          const navigationItem = document.querySelectorAll(navigationItems);
          if (!swiperElement || !navigationItem) return { unload: null };
          const handleSwatches = () => {
            const swatchesContainer = document.querySelectorAll(
              ".js-product-card-swatch"
            );
            if (swatchesContainer)
              swatchesContainer.forEach((swatch) => {
                swatch.addEventListener("change", async () => {
                  if (swatch instanceof HTMLInputElement) {
                    const productCardContainer =
                      swatch.closest(".js-product-card");
                    if (productCardContainer) {
                      var _productCardContainer_querySelector;
                      null ===
                        (_productCardContainer_querySelector =
                          productCardContainer.querySelector(
                            ".js-product-card-swatch.selected"
                          )) || void 0 === _productCardContainer_querySelector
                        ? void 0
                        : _productCardContainer_querySelector.classList.remove(
                            "selected"
                          );
                      const imgURL = swatch.getAttribute("data-img");
                      const secondImgURL =
                        swatch.getAttribute("data-second-img");
                      const productURL = swatch.getAttribute("data-url");
                      const productPrice =
                        swatch.getAttribute("data-price") || "";
                      const productImage = productCardContainer.querySelector(
                        ".js-product-card-image"
                      );
                      const productPriceSelector =
                        productCardContainer.querySelector(
                          ".js-product-card-price"
                        );
                      const secondImage = productCardContainer.querySelector(
                        ".js-product-card-second-image"
                      );
                      const productLink = productCardContainer.querySelectorAll(
                        ".js-product-card-link"
                      );
                      if (productImage instanceof HTMLImageElement && imgURL)
                        productImage.src = imgURL;
                      if (
                        secondImage instanceof HTMLImageElement &&
                        secondImgURL
                      )
                        secondImage.src = secondImgURL;
                      if (
                        productPriceSelector instanceof HTMLElement &&
                        productPriceSelector
                      )
                        productPriceSelector.innerHTML = productPrice;
                      if (productLink && productURL)
                        productLink.forEach((productCardlink) => {
                          productCardlink.setAttribute("href", `${productURL}`);
                        });
                    }
                  }
                });
              });
          };
          swiper__WEBPACK_IMPORTED_MODULE_0__["default"].use([
            swiper__WEBPACK_IMPORTED_MODULE_0__.Navigation,
            swiper__WEBPACK_IMPORTED_MODULE_0__.Pagination,
            swiper__WEBPACK_IMPORTED_MODULE_0__.Lazy,
            swiper__WEBPACK_IMPORTED_MODULE_0__.Scrollbar,
          ]);
          const settings = {
            scrollbar: {
              el: ".js-simple-featured-products-carousel .tvg-swiper-scrollbar",
              draggable: true,
            },
            navigation: {
              nextEl:
                ".js-simple-featured-products-carousel .tvg-swiper-button-next",
              prevEl:
                ".js-simple-featured-products-carousel .tvg-swiper-button-prev",
            },
            lazy: { loadPrevNext: true },
            slidesPerView: "auto",
            centeredSlides: false,
            loop: false,
            breakpoints: { 1024: { slidesPerView: "auto" } },
          };
          mySwiper = new swiper__WEBPACK_IMPORTED_MODULE_0__["default"](
            ".js-simple-featured-products-carousel",
            settings
          );
          jquery__WEBPACK_IMPORTED_MODULE_1___default()(
            navigationItems,
            section
          ).on("click", function () {
            jquery__WEBPACK_IMPORTED_MODULE_1___default()(
              navigationItems,
              section
            )
              .removeClass("active")
              .attr("aria-selected", "false");
            jquery__WEBPACK_IMPORTED_MODULE_1___default()(this)
              .addClass("active")
              .attr("aria-selected", "true");
            const collection =
              jquery__WEBPACK_IMPORTED_MODULE_1___default()(this).attr(
                "collection-name"
              );
            const collectionUrl =
              jquery__WEBPACK_IMPORTED_MODULE_1___default()(this).attr(
                "collection-url"
              );
            const collectionLabel =
              jquery__WEBPACK_IMPORTED_MODULE_1___default()(this).attr(
                "collection-label"
              ) || "";
            jquery__WEBPACK_IMPORTED_MODULE_1___default()(
              navigationAll,
              section
            ).attr("href", collectionUrl || "");
            jquery__WEBPACK_IMPORTED_MODULE_1___default()(
              navigationAll,
              section
            ).text(collectionLabel);
            jquery__WEBPACK_IMPORTED_MODULE_1___default()(
              featuredSlide,
              section
            ).css("display", "none");
            jquery__WEBPACK_IMPORTED_MODULE_1___default()(
              `.js-simple-featured-products-carousel-slide[data-collection="${collection}"]`,
              section
            )
              .css("display", "block")
              .addClass("swiper-slide");
            mySwiper = new swiper__WEBPACK_IMPORTED_MODULE_0__["default"](
              swiperElement,
              settings
            );
          });
          jquery__WEBPACK_IMPORTED_MODULE_1___default()(
            navigationItems,
            section
          )
            .first()
            .trigger("click");
          handleSwatches();
          return {
            unload: () => {
              section.off(NAMESPACE);
            },
          };
        }
      );
    },
  },
  (__webpack_require__) => {
    var __webpack_exec__ = (moduleId) =>
      __webpack_require__((__webpack_require__.s = moduleId));
    __webpack_require__.O(0, [351], () => __webpack_exec__(694));
    var __webpack_exports__ = __webpack_require__.O();
  },
]);
